module.exports = __webpack_public_path__ + "static/media/edit_orange.5be29899.png";